import React from "react";
import MyGoalCard from "../MyGoalCard/MyGoalCard";
import PersonalGoalCard from "./PersonalGoalCard/PersonalGoalCard";

const PersonalGoal = () => {
    const [addOpen, setAddOpen] = React.useState(false);
  const HandlerAddPersonalGoal = () => {
    setAddOpen(true);
  };
  return (
    <>
      <MyGoalCard handleClick={HandlerAddPersonalGoal} title={"Personal Goal"} action={'Add Personal Goal'}>
        <div className="personalGoadCardContainer"> 
         {[1,2,3,4,5].map((_, index) => (
          <PersonalGoalCard addOpen={addOpen} setAddOpen={setAddOpen} />
         ))}
        </div>
      </MyGoalCard>
    </>
  );
};

export default PersonalGoal;
